<template>
  <v-toolbar :color="color ? color : 'primary'">
    <!--<v-toolbar-side-icon></v-toolbar-side-icon>-->
    <v-toolbar-title class="white--text capitalize">
      <slot></slot>
    </v-toolbar-title>
    <v-spacer></v-spacer>
  </v-toolbar>
</template>
<script>
export default {
  props: ['color'],
};
</script>

<style>
.capitalize {
  text-transform: capitalize;
}
</style>
